module.exports = __webpack_public_path__ + "static/media/Icon-awesome-pen-fancy.ac245fdd.svg";